import React from 'react';
import EcardFileViewerButton from '../../../Ecard/Components/EcardFileViewer/EcardFileViewerButton';
import Text from '../../../../Components/Base/Text/Text';
// @ts-ignore
import styles from './CaseMedicalReportButtonList.module.scss';
import { SyncStatusState } from '../../../../graphql/graphql';
import SavingSpinner from '../../../../Components/Base/Loading/SavingSpinner';
import MarkFileAsPrintedOut from '../../../Files/Component/MarkFileAsPrintedOut';
import { CaseItemMedicalReport } from '../../Interfaces/Case.interface';

interface Props {
	items: CaseItemMedicalReport[];
	patientId: string;
	allowPrintedMarking?: boolean;
}

const CaseMedicalReportButtonList: React.FC<Props> = ({
	items,
	patientId,
	allowPrintedMarking = false,
}) => {
	return (
		<>
			{items.map(item => {
				return (
					<div key={item.id}>
						<EcardFileViewerButton key={item.id} item={item} />
						{item?.document?.sync?.state === SyncStatusState.Pending && (
							<div className='d-flex justify-content-center'>
								<SavingSpinner tx='component.closedCasesListItem.pending' />
							</div>
						)}
						{item?.document?.sync?.state === SyncStatusState.Finished && (
							<div className={styles.status}>
								<img src='/dist/icons/v2/badge-check.svg' alt='Check' />
								<Text
									tx='component.closedCasesListItem.finished'
									className={styles.statusText}
								/>
							</div>
						)}
						{item?.document?.sync?.state === SyncStatusState.Error && (
							<div className={styles.status}>
								<img src='/dist/icons/alert-red.svg' alt='alert' />
								<Text
									tx='component.closedCasesListItem.error'
									className={styles.statusText}
								/>
							</div>
						)}
						{allowPrintedMarking && (
							<div className={styles.checkboxWrapper}>
								<MarkFileAsPrintedOut
									fileId={item.fileId}
									printed={item.printed}
									patientId={patientId}
								/>
							</div>
						)}
					</div>
				);
			})}
		</>
	);
};

export default CaseMedicalReportButtonList;
